<template>
    <div>
        <!-- Toggle for free input field for return or global reasons for claims -->
        <div class="flex justify-center mb-6" v-if="globalReasons.length > 0">
            <div class="flex flex-col">
                <div class="flex item-center">
                    <input type="checkbox" id="return-all" v-model="form.reasonForAllChecked" class="h-6 w-6 mr-4">
                    <label for="return-all">{{translations.check_all_article}}</label>
                </div>
            </div>
        </div>

        <!-- Free input field for return if whole order is returned-->
        <Input
            :label="translations.reason_all_orders"
            class="pt-3 px-4 md:px-0"
            v-if="form.reasonForAllChecked && isReturn"
            :placeholder="translations.please_specifiy"
            v-model="form.reasonForAllText"
            idAttr="reasonForAllText"
        />

        <!-- Global reasons for claims -->
        <div class="pt-3 px-4 md:px-0" v-if="form.reasonForAllChecked && !isReturn">
            <label for="multiselectReason" class="uppercase disabled:opacity-25 block pb-3">{{translations.reason_all_orders}}</label>
            <VueMultiselect
                v-model="form.addedGlobalReasons"
                :options="globalReasons"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :placeholder="translations.select_reason"
                label="name"
                track-by="id"
                id="multiselectReason"
                :preselect-first="false"
                :searchable="false"
                selectLabel=""
                selectedLabel=""
                deselectLabel=""
            >
                <template
                    v-slot:selection="{ values, isOpen }">
                    <span
                    class="multiselect__single multiselect__placeholder__custom"
                    v-if="values.length && !isOpen"
                    >
                        {{ values.length }} {{translations.x_reasons_selected}}
                    </span>
                    <span class="multiselect__placeholder__custom" v-else-if="isOpen">{{translations.select_reason}}</span>
                </template>
            </VueMultiselect>

            <!-- Image uploads for Global reasons -->
            <div v-if="form.addedGlobalReasons.length" v-for="(reason, index) in form.addedGlobalReasons">
                <Input class="pt-3" v-if="reason.optional_text" v-model="reason.text" :idAttr="'reason' + index" :label="reason.name" :placeholder="translations.please_specifiy" />
                <div v-if="reason.photo_upload">
                    <p class="my-3 font-medium">{{reason.name}}</p>
                    <p class="mb-3">{{ translations.image_upload_desc_global }}</p>
                    <div class="w-full md:w-2/3">
                        <div class="my-3 flex gap-3">
                            <div v-for="(image, index) in reason.images" :key="index" class="relative shadow">
                                <span
                                    class=" text-red-500 text-2xl absolute top-0 right-0 font-bold"
                                    @click="removeImage(index, reason)"
                                >
                                X
                                </span>
                                <Image :imageUrl="createUrl(image)" style="width:65px;"/>
                            </div>
                        </div>
                        <p class="text-red-500 text-sm italic" :class="{'hidden': imageErrorIndex != index}">{{ translations.file_less_than }}</p>
                    </div>
                    <label class="button button-primary">
                        {{translations.image_upload_btn}}
                        <input accept="image/x-png, image/jpeg" type="file" ref="uploader" style="display: none" @input="addImage($event.target.files[0], reason, index)" />
                    </label>
                    <p class="text-sm italic">{{ translations.permitted_file_types }}</p>
                    <p class="text-sm italic">{{ translations.file_less_than }}</p>
                </div>
            </div>
        </div>

        <!-- List all articles in order(s) -->
        <template v-for="(order, indexOrder) in orders">
            <Article
                v-for="(row, indexRow) in order.filteredRows"
                :toggleArticle="form.reasonForAllChecked"
                @update:modelValue="addArticle(row, $event)"
                :row="row"
                :translations="translations"
                :key="row.order_row_id"
                :isReturn="isReturn"
                :addedGlobalReasons="form.addedGlobalReasons"
            />
        </template>

        <!-- Free text field for claim -->
        <TextArea
            :label="translations.claim_free_text_label"
            class="pt-3 px-4 md:px-0"
            v-if="!isReturn"
            v-model="form.reasonForAllText"
            idAttr="reasonForAllTextClaim"
            :translations="translations"
        />

        <!-- Buttons for continue/back and warnings -->
        <div class="flex mt-8 md:mt-12 flex-col mx-4 md:mx-0">
            <div class="text-center mb-5 md:mb-9" v-if="(!articleAdded || !reasonAdded) && (translations.added_article_required && translations.reason_required) ">
                <p class="text-red-500 text-sm pb-3 italic" v-if="!articleAdded">{{ translations.added_article_required }}</p>
                <p class="text-red-500 text-sm pb-3 italic" v-if="!reasonAdded && form.reasonForAllText == ''">{{ translations.reason_required }}</p>
            </div>
            <Button :disabled="!enableContinue" :text="translations.continue_button" class="mb-6" @click="$emit('continue', form)"/>
            <ButtonWhite :text="translations.back" @click="$emit('back')" />
        </div>
    </div>
</template>

<script>
import Article from '@/Components/Article'
import Image from '@/Components/Image'
import VueMultiselect from 'vue-multiselect'
import TextArea from '@/Components/TextArea'
export default {
    components: {
        Article,
        Image,
        VueMultiselect,
        TextArea
    },
    props: {
        globalReasons: Array,
        orders: Array,
        isReturn: Boolean,
        translations: Object
    },
    data() {
        return {
            enableContinue: false,
            articleAdded: false,
            reasonAdded: false,
            missingBatchCodes: false,
            imageErrorIndex: null,
            form: {
                reasonForAllChecked: false,
                selectedArticles: {},
                reasonForAllText: null,
                addedGlobalReasons: [],
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler() {
                this.shouldEnableContinue()
            }
        }
    },
    methods: {
        addArticle(orderRow, event) {
            if(event) {
                this.form.selectedArticles[orderRow.id] = event
            } else {
                delete this.form.selectedArticles[orderRow.id]
            }
        },
        /**
         * Check if we should enable the continue button
         * We'll enable the continue button if atleast one article has been added and that article has a return reason if return reasons exists
         * In those cases that no return reason exist(null) for that article category we will still enable continue if an article has been added without reason
         * Or if global return reason exist and atleast 1 article is added continue should be enabled
         *
         * If frame is added for claim check if batch code is needed for that supplier (Certain reasons such as missing article disables the need for batch code)
         * Check if article reason requires image proof and image is uploaded.
         */
        shouldEnableContinue() {
            this.articleAdded = false
            this.reasonAdded = false
            this.missingBatchCodes = false
            for (const key in this.form.selectedArticles) {
                if (this.form.selectedArticles.hasOwnProperty(key)) {
                    let article = this.form.selectedArticles[key]
                    if(article) {
                        this.articleAdded = true
                        if(!this.form.reasonForAllChecked) {
                            this.reasonAdded = this.articlePasses(article) && this.checkArticleImageRequirement(article)
                            //If any article is missing reason we stop.
                            if(!this.reasonAdded) {
                                break
                            }
                        }
                    }
                    if(!this.checkForBatchCode(article)) {
                        this.missingBatchCodes = true
                        break
                    }
                }
            }

            this.enableContinue =
                this.isGlobalReturnReason()
                || this.isGlobalClaimsReason()
                || (this.articleAdded && this.reasonAdded && !this.missingBatchCodes)
        },

        //Check if global reason has been added for the return and a text is entered
        isGlobalReturnReason() {
            return this.form.reasonForAllChecked // Global reason is checked
            && this.form.reasonForAllText != null // Global return reason free text added
            && this.form.reasonForAllText != '' // Global return reason free text added
            && this.articleAdded // Atleast 1 article is added
            && this.isReturn // Is return errand
        },

        //Check if global reason has been added for the claim
        isGlobalClaimsReason() {
            return this.form.reasonForAllChecked // Global reason is checked
            && this.form.addedGlobalReasons.length > 0 // Atleast 1 global reason has been added
            && this.articleAdded // Atleast 1 article is added
            && !this.missingBatchCodes // Batch codes are added if needed
            && this.checkGlobalImageRequirement() // Images has been uploaded if required by global reason
        },

        checkGlobalImageRequirement() {
            let pass = true
            this.form.addedGlobalReasons.forEach(reason => {
                if(reason && reason.photo_upload && (reason.images == null || reason.images.length == 0)) {
                    pass = false
                }
            })
            return pass
        },

        checkArticleImageRequirement(article) {
            let pass = true
            if(!this.isReturn && article.reasons) {
                article.reasons.forEach(reasonQuant => {
                    reasonQuant.forEach(reason => {
                        if(reason && reason.photo_upload && (reason.images == null || reason.images.length == 0)) {
                            pass = false
                        }
                    })
                })
            }
            return pass
        },

        checkForBatchCode(article) {
            let check = true
            if(article.batch_codes != null) {
                check = false
                let passes = 0
                article.batch_codes.forEach(code => {
                    if(!code.require_batch_code || (code.code != null && code.code != '')) {
                        passes++
                    }
                })
                check = passes == article.quantity ? true : false
            }
            return check
        },

        // Passes if article has reason added, or in the case that this article category doesn't yet has any reasons.
        // For claims we have to check per quantity
        articlePasses(article) {
            let pass = article.reasons == null ? true : false
            if(this.isReturn && article.reasons != null) {
                pass = article.reasons.length > 0
            } else {
                if(article.reasons != null) {
                    let passes = 0
                    article.reasons.forEach(reason => {
                        if(reason.length > 0) {
                            passes++
                        }
                    })
                    pass = passes == article.quantity ? true : false
                }
            }
            return pass
        },
        addImage(image, reason, index) {
            this.imageErrorIndex = null
            //Sometimes addImage gets called even if file opener gets cancelled.
            if(!image) {
                return
            }
            //Only allow images that are less than 10mb
            if (image.size / (1024 * 1024) > 10) {
                this.imageErrorIndex = index
                return
            }
            if(!reason.images) {
                reason.images = []
            }
            reason.images.push(image)
        },
        createUrl(image) {
            return URL.createObjectURL(image)
        },
        removeImage(index, reason) {
            reason.images.splice(index, 1)
        },
    },
}
</script>
